import { IconButton } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import colors from "../theme/themeConstants";
import { SearchInput } from "components/UI/SearchInput";
import { HeaderButton } from "./buttons/HeaderButton";
import { toggleBurgerMenu } from "store/application/application-action";
import { useSelector, useDispatch } from "react-redux";
import { IAppState } from "../store/app-state";
import { RGLogo } from "components/UI/RGLogo";
import AdTabs from "./ads/AdTabs";
import { TABLET_WIDTH } from "hooks/useDeviceType";

import "./ApplicationHeader.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "routes";
import CrossIcon from "./icons/Components/CrossIcon";
import { Fragment } from "react";

export default function ApplicationHeader() {
  const isSearchBarOpen = useSelector((state: IAppState) => state.application.isSearchBarOpen);
  const isDesktop = useMediaQuery(`(min-width: ${TABLET_WIDTH}px)`);
  const dispatch = useDispatch();
  const isShowSearchElems = isDesktop || (!isDesktop && !isSearchBarOpen);

  const location = useLocation();
  const navigate = useNavigate();

  const handleBurgerMenuButton = () => {
    dispatch(toggleBurgerMenu());
  };

  return (
    <>
      {!location.pathname.includes(routes.create()) ? (
        <div className="topNav">
          {isShowSearchElems && <RGLogo />}
          {!isSearchBarOpen && <AdTabs />}
          <SearchInput/>
          {isShowSearchElems && <HeaderButton onClick={handleBurgerMenuButton}/>}
        </div>
      ) : (
        <div className="topNav">
          {isShowSearchElems && <RGLogo />}
          {isDesktop ? (
            <Fragment>
              {!isSearchBarOpen && <AdTabs />}
              <SearchInput/>
              {isShowSearchElems && <HeaderButton onClick={handleBurgerMenuButton}/>}
            </Fragment>
          ) : (
            <Fragment>
              <p className="nav-upload">Upload</p>
              <IconButton
                sx={{
                  transform: "rotate(45deg)",
                  color: colors.lightGrayText,
                  background: colors.lightGray_GoBackButton
                }}
                onClick={() => navigate(-1)}
              >
                <CrossIcon/>
              </IconButton>
            </Fragment>
          )}
        </div>
      )}
    </>
  );
}
